import { render } from "./StartYearWizardGuideDialog.vue?vue&type=template&id=6a947c35"
import script from "./StartYearWizardGuideDialog.vue?vue&type=script&lang=js"
export * from "./StartYearWizardGuideDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent\\_work\\82\\s\\SimpleSums\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__